import { getQuery } from '@/common/utils';
import { pageType } from './base';

const QUERY_KEY = 'themeactivitytype';

function findThemeActivityTypeByQuery(query: string) {
  const value = getQuery(QUERY_KEY, query);
  return {
    isPromotion() {
      return value === pageType.promotion;
    },
    isChannel() {
      return value === pageType.channel;
    },
    get() {
      return value;
    },
  };
}

function getThemeActivityTypePromotionQuery() {
  return `${QUERY_KEY}=${pageType.promotion}`;
}

function getThemeActivityTypeChannelQuery() {
  return `${QUERY_KEY}=${pageType.channel}`;
}

function getThemeActivityTypeQuery(type: any) {
  if (type === pageType.channel) return getThemeActivityTypeChannelQuery();
  else return getThemeActivityTypePromotionQuery();
}

export default {
  promotion: pageType.promotion,
  channel: pageType.channel,
  findThemeActivityTypeByQuery,
  getThemeActivityTypePromotionQuery,
  getThemeActivityTypeChannelQuery,
  getThemeActivityTypeQuery,
};
